import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

import { signatureApi } from '../../axios/signature';
import { useLanguage } from '../../hooks';
import { AnswerViewExpiredLinkIcon } from '../icons/answerViewExpiredLinkIcon';
import { DsBanner } from '../uiComponents/CommonComponents/DsBanner';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flexGrow: 1,
    backgroundColor: '#FAFBFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    boxSizing: 'border-box',
  },
  content: {
    maxWidth: '472px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imageContainer: {
    height: 'auto',
    width: '100%',
    maxWidth: '250px',
    maxHeight: '250px',
    marginBottom: '30px',
  },
  image: {
    height: '100%',
    width: 'auto',
  },
  description: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    maxWidth: '475px',
    textAlign: 'center',
    color: (theme) => theme.palette.secondary.main,
    marginBottom: '30px',
  },
};

export function AnswerViewExpiredLink() {
  const lang = useLanguage();
  const { enqueueSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [disabled, setDisabled] = useState(false);

  const handleRequestNewLink = async () => {
    setDisabled(true);
    try {
      await signatureApi.externalUserRequestNewLink(token);
      enqueueSnackbar(lang.answerView.expiredLink.newLinkRequestedSuccess, {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(lang.answerView.expiredLink.newLinkRequestedError, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={customStyles.root}>
      <DsBanner />
      <Box sx={customStyles.container}>
        <Box sx={customStyles.content}>
          <Box sx={customStyles.imageContainer}>
            <AnswerViewExpiredLinkIcon sx={customStyles.image} />
          </Box>
          <Typography
            variant='h1'
            sx={customStyles.description}
          >
            {lang.answerView.expiredLink.description}
          </Typography>
          <Button
            disabled={disabled}
            variant='contained'
            fullWidth
            onClick={handleRequestNewLink}
          >
            {lang.answerView.expiredLink.button}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
